<template>
    <client-page>
        <sub-visual tit="제품문의" bg="/images/sub/visual/sv--inquiry.jpg"></sub-visual>

        <section class="section secondary color-white">
            <v-container>
                <div class="d-flex align-end justify-space-between mb-20 mb-lg-40">
                    <h5 class="tit-txt font-weight-bold letter-spacing-6 line-height-1">
                        INQUIRY
                    </h5>
                    <v-spacer />
                    <v-col cols="auto" class="pa-0" v-if="catalog">
                        <v-btn small plain tile color="white" :href="`/res/catalog/${catalog.filename}`" target="_blank" class="transparent text-btn d-flex align-center px-4" style="border-radius: 0!important;">
                            일반 카탈로그 <i class="icon icon-download"></i>
                        </v-btn>
                        <!-- <a :href="`/res/catalog/${catalog.filename}`" target="_blank" class="text-btn d-flex align-center">일반 카탈로그 <i class="icon icon-download"></i></a> -->
                    </v-col>
                    <v-col cols="auto" class="ml-12 pa-0" v-if="catalog2">
                        <v-btn small plain tile color="white" :href="`/res/catalog2/${catalog2.filename}`" target="_blank" class="transparent text-btn d-flex align-center px-4" style="border-radius: 0!important;">
                            아트배너 스탠드 카탈로그 <i class="icon icon-download"></i>
                        </v-btn>
                        <!-- <a :href="`/res/catalog/${catalog2.filename}`" target="_blank" class="text-btn d-flex align-center">아트배너 스탠드 카탈로그 <i class="icon icon-download"></i></a> -->
                    </v-col>
                    <!-- <button class="text-btn d-flex align-center" @click="download(`/res/catalog/${catalog.filename}`, '카탈로그')">카탈로그 <i class="icon icon-download"></i></button> -->
                    <!-- <button class="text-btn d-flex align-center" @click="view = true">카탈로그</button>
                    <v-dialog v-model="view" width="1024" height="1">
                        <embed :src="`/res/catalog/${catalog.filename}`" type="application/pdf"/>
                    </v-dialog> -->
                </div>
                <div>
                    <v-row class="row--large">
                        <v-col cols="12" lg="6">
                            <v-text-field  v-model="input.name" ref="name" hide-details outlined label="이름"></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-text-field  v-model="input.email" ref="email" hide-details outlined label="이메일"></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-text-field v-model="input.companyName" ref="companyName" hide-details outlined label="회사명"></v-text-field>
                        </v-col>
                        <v-col cols="12" lg="6">
                            <v-text-field  v-model="input.phone" ref="phone" hide-details outlined label="전화번호"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="input.type" ref="type" hide-details outlined label="문의내용"></v-textarea>
                            <!-- <v-text-field  v-model="input.type" ref="type" hide-details outlined label="문의내용"></v-text-field> -->
                        </v-col>
                    </v-row>
                    <div class="mt-30 mt-lg-50 d-flex justify-center align-center">
                        <v-checkbox label="개인정보 처리방침에 동의합니다." hide-details v-model="agree"></v-checkbox>
                        <v-btn onclick="window.open('/privacy', '', 'width=483,height=700');" small text color="grey-7" class="ml-6">약관보기</v-btn>
                    </div>
                    <div class="mt-50 mt-lg-100 d-flex justify-center">
                        <v-btn @click="send" large color="primary" class="v-btn--primary">
                            <span class="secondary--text">문의하기</span>
                            <i class="icon icon-right-arrow ml-12 ml-lg-20"></i>
                        </v-btn>
                    </div>
                </div>
            </v-container>
        </section>

        <section class="section">
            <v-container>
                <v-row class="row--large">
                    <v-col cols="12" md="6">
                        <h5 class="tit-txt font-weight-bold letter-spacing-6 line-height-1">
                            CONTACT US DIRECTLY
                        </h5>
                        <v-divider class="border-color-secondary my-20 my-lg-40"></v-divider>
                        <ul class="page-text--sm line-height-1">
                            <li class="d-flex mb-8 mb-lg-30">
                                <p class="info-tit font-weight-bold mr-14 mr-lg-40" data-aos="fade-right">
                                    Company
                                </p>
                                <p class="color-grey-7" data-aos="fade-left">
                                    민아트프레임
                                </p>
                            </li>
                            <li class="d-flex mb-8 mb-lg-30">
                                <p class="info-tit font-weight-bold mr-14 mr-lg-40" data-aos="fade-right">
                                    Zip Code
                                </p>
                                <p class="color-grey-7" data-aos="fade-left">
                                    18284
                                </p>
                            </li>
                            <li class="d-flex mb-8 mb-lg-30">
                                <p class="info-tit font-weight-bold mr-14 mr-lg-40" data-aos="fade-right">
                                    Address
                                </p>
                                <p class="color-grey-7" data-aos="fade-left">
                                    <a target="_blank" href="https://naver.me/GIGY0cVz">
                                    <!-- <a target="_blank" href="https://www.google.com/maps/place/%EB%AF%BC%EC%95%84%ED%8A%B8%ED%94%84%EB%A0%88%EC%9E%84/data=!3m1!4b1!4m6!3m5!1s0x357c9f7ab2b3ec59:0x40a3fb94d5273f9f!8m2!3d37.2365537!4d126.8726446!16s%2Fg%2F1tj94b_t?hl=ko"> -->
                                        경기도 화성시 비봉면 양노로 103
                                    </a>
                                </p>
                            </li>
                            <li class="d-flex mb-8 mb-lg-30">
                                <p class="info-tit font-weight-bold mr-14 mr-lg-40" data-aos="fade-right">
                                    Email
                                </p>
                                <p class="color-grey-7" data-aos="fade-left">
                                    <a target="_blank" href="mailto:minart369@naver.com">minart369@naver.com</a>
                                </p>
                            </li>
                            <li class="d-flex mb-8 mb-lg-30">
                                <p class="info-tit font-weight-bold mr-14 mr-lg-40" data-aos="fade-right">
                                    Website
                                </p>
                                <p class="color-grey-7" data-aos="fade-left">
                                    <router-link to="/">minart.com</router-link>
                                </p>
                            </li>
                            <li class="d-flex">
                                <p class="info-tit font-weight-bold mr-14 mr-lg-40" data-aos="fade-right">
                                    Tel / Fax
                                </p>
                                <p class="color-grey-7" data-aos="fade-left">
                                    <a target="_blank" href="tel:031-465-9088">031-465-9088</a> / 031-465-9098
                                </p>
                            </li>
                        </ul>
                    </v-col>
                    <v-col cols="12" md="6">
                        <div class="rounded mt-md-40 mt-lg-62">
                            <naver-map height="366" />
                            <!-- <iframe class="w-100 d-block" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3176.470045870956!2d126.8726446!3d37.23655370000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9f7ab2b3ec59%3A0x40a3fb94d5273f9f!2z66-87JWE7Yq47ZSE66CI7J6E!5e0!3m2!1sko!2skr!4v1675299710918!5m2!1sko!2skr" width="100%" height="366" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <!-- <v-card-title>제품문의</v-card-title>
        <v-card>
            <v-card-subtitle>IMQUIRY</v-card-subtitle>
            <v-text-field v-model="input.companyName" label="회사명"></v-text-field >
            <v-text-field  v-model="input.name" label="이름"></v-text-field >
            <v-text-field  v-model="input.email" label="이메일"></v-text-field >
            <v-text-field  v-model="input.phone" label="전화번호"></v-text-field >
            <v-text-field  v-model="input.type" label="문의종류"></v-text-field >
        </v-card>
        <v-btn @click="send">문의하기</v-btn> -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";

import api from "@/api";
import download from "downloadjs";
import NaverMap from '@/components/client/naver/naver-map.vue';

export default {
    components: {
        ClientPage,
        SubVisual,
        NaverMap,
    },
    data() {
        return {
            input: {
                companyName: null,
                name: null,
                email: null,
                phone: null,
                type: null,
                language: "ko"
            },
            catalog: null,
            agree: false
            // view: false,
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        validate(){
            try{
                if(!this.input.name) {
                    alert("이름을 입력해 주세요");
                    this.$refs.name.focus();
                    return false;
                }
                if(!this.input.email) {
                    alert("이메일을 입력해 주세요");
                    this.$refs.email.focus();
                    return false;
                }
                if(!this.input.companyName) {
                    alert("회사명을 입력해 주세요");
                    this.$refs.companyName.focus();
                    return false;
                }
                if(!this.input.phone) {
                    alert("핸드폰 번호를 입력해 주세요");
                    this.$refs.phone.focus();
                    return false;
                }
                if(!this.input.type) {
                    alert("문의내용을 입력해 주세요");
                    this.$refs.type.focus();
                    return false;
                }
                if(!this.agree) {
                    alert("개인정보 처리방침에 동의해 주세요");
                    this.$refs.type.focus();
                    return false;
                }
                return true
            }
            catch(error){
                alert(error.message);
                return false;
            }
        },
        async send() {
            if(this.validate()) {
                await api.v1.forms.post(this.input);
                alert("문의 신청이 접수됐습니다.")
                this.$router.go(0);
            }
        },
        async init() {
            let { setting } = await api.v1.setting.get();
            this.catalog = setting.surveyURL;
            this.catalog2 = setting.surveyURL2;
            // console.log(this.catalog, "catalog");
        },
        download(path, rename){
            api.getResource(path).then(file => download(file, rename));
        }
    },
};
</script>

<style scoped>
.info-tit{
    min-width: 55px;
    width: 55px;
    /* height: 16px;
    overflow: hidden;
	text-align:justify;
	vertical-align:middle; */
}
/* .info-tit::after{
    content:'';
	display:inline-block;
	width:100%;
} */

@media (min-width:576px){
}
@media (min-width:768px){
    .info-tit .space{
        display: inline;
    }
}
@media (min-width:1024px){
    .info-tit{
        min-width: 70px;
        width: 70px;
    }
}
@media (min-width:1200px){
}
</style>
